import { Star, Quote } from "lucide-react";
import { MEDIA, TESTIMONIALS } from "../../lib/content";

export const Testimonials = () => {
  return (
    <section id="reviews" data-testid="testimonials-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img src={MEDIA.barkTexture} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A0A0A]/92" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="font-cursive text-gold text-2xl md:text-3xl">Real Results</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mt-1">What Our Clients Say</h2>
          <div className="gold-divider w-40 mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#111111]/80 backdrop-blur-sm border border-gold/20 rounded-xl p-8 hover:border-gold/50 transition-colors"
            >
              <Quote className="text-gold/40" size={36} />
              <div className="flex text-gold mt-4 mb-4">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={s} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="text-gray-200 leading-relaxed italic">"{t.quote}"</p>
              <div className="mt-6 pt-4 border-t border-gold/10">
                <p className="font-serif text-white text-lg">{t.name}</p>
                <p className="text-xs uppercase tracking-widest text-gold">{t.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
